/**
 * Normalizes an email address so it can be checked for uniqueness with other
 * email address.  The normalization is 1) strip spaces 2) convert to lower case.
 * For @gmail.com and @googlemail.com some additional normalization is performed:
 * 1) strip everything after a +, 2) strip all dots, 3) always use @gmail.com.  That
 * special gmail normalization is only performed for gmail, not google backed email
 * domains (like zola).
 *
 * @param {*} email - weird email address
 * @return {string} - normalized email address
 */
export function normalizeReviewEmailAddress(email: string): string;
export function normalizeReviewEmailAddress(email: undefined): undefined;
export function normalizeReviewEmailAddress(email: string | undefined): string | undefined {
  if (typeof email !== 'string') {
    return email;
  }

  const stripedLowerEmail = email.toLocaleLowerCase().trim();

  const parts = stripedLowerEmail.split(/@/);
  if (parts.length < 2) {
    return stripedLowerEmail;
  }

  const domain = parts[parts.length - 1];
  if (!(domain === 'gmail.com' || domain === 'googlemail.com')) {
    return stripedLowerEmail;
  }

  // This isn't checking that the email is actually valid, so join the parts without the domain back together
  const userName = parts.slice(0, parts.length - 1).join('');

  // Remove anything after a +
  const userNameWithoutPlus = userName.split(/\+/)[0];

  // Remove _all_ the dots
  const userNameWithoutDots = userNameWithoutPlus.replace(/\./g, '');

  // Normalize @googlemail to @gmail
  return `${userNameWithoutDots}@gmail.com`;
}
